import React from 'react';
import { DesktopCarousel } from './DesktopCarousel';
import { MobileCarousel } from './MobileCarousel';
import styles from './Summary.module.scss';
import cls from 'classnames';
import { CursorIcon } from 'components/Icons/Icons';
import { TraitDisplayCard } from 'components/TraitCard/TraitDisplayCard';
import { TraitRevealCard } from 'components/TraitCard/TraitRevealCard';
import { RevealedGribble } from './state-machine';
import { traitAttributesTransformer } from 'components/TraitCard/transformer';
import { CollectionEntities } from 'components/Collection/model';

export type CarouselProps = {
  // TODO: add type when we add the BE endpoints.
  currentGribble: RevealedGribble;
  gribbleCount: number;
  index?: number;
  last?: boolean;
  first?: boolean;
  next: () => void;
  prev: () => void;
  stage?: 'properties' | 'colors' | 'revealed';
  revealAll?: () => void;
  currentStageRevealed?: boolean;
  revealOne?: (property: any) => void;
  finish: () => void;
};

export const Summary = (props: CarouselProps) => {
  return (
    <div className={styles.summaryContainer}>
      <DesktopCarousel {...props} />
      <MobileCarousel {...props} />
    </div>
  );
};

type PositionDotsProps = {
  gribbleCount: number;
  index?: number;
};

export const PositionDots = ({ gribbleCount, index }: PositionDotsProps) => (
  <div className={styles.dots}>
    {gribbleCount > 1 &&
      Array(gribbleCount)
        .fill('a')
        .map((_, i) => (
          <div className={cls(styles.dot, { [styles.filledDot]: index === i })} key={i}></div>
        ))}
  </div>
);

type RevealHeaderProps = {
  stage?: 'properties' | 'colors' | 'revealed';
};

export const RevealHeader = ({ stage }: RevealHeaderProps) => (
  <div className={styles.revealHeader}>
    <div className={styles.cursorIcon}>
      <CursorIcon />
    </div>
    <p className="subheading-default">
      Click to reveal Gribble {stage === 'colors' ? 'color' : 'shape'} properties
    </p>
  </div>
);

type GribblePropertiesProps = {
  isRevealing: boolean;
  currentGribble: RevealedGribble;
  stage?: 'properties' | 'colors' | 'revealed';
  small?: boolean;
  revealOne?: (property: any) => void;
};

export const GribbleProperties = ({
  isRevealing,
  currentGribble,
  stage,
  revealOne,
  small,
}: GribblePropertiesProps) => (
  <>
    {!isRevealing && (
      <>
        {currentGribble.properties.map((property) => (
          <TraitDisplayCard
            small={small}
            key={property.traitType}
            {...traitAttributesTransformer.toTraitAttribute(
              { traitType: property.traitType, value: property.value.toString() },
              CollectionEntities.Gribbles,
            )}
          />
        ))}
        {currentGribble.colors.map((property) => (
          <TraitDisplayCard
            small={small}
            key={property.traitType}
            {...traitAttributesTransformer.toTraitAttribute(
              { traitType: property.traitType, value: property.value.toString() },
              CollectionEntities.Gribbles,
            )}
          />
        ))}
      </>
    )}
    {stage === 'colors' &&
      currentGribble.colors.map((property) => (
        <div
          className={styles.property}
          key={property.traitType}
          onClick={() => revealOne?.(property.traitType)}
        >
          <TraitRevealCard
            {...traitAttributesTransformer.toTraitAttribute(
              { traitType: property.traitType, value: property.value.toString() },
              CollectionEntities.Gribbles,
            )}
            flipped={property.revealed}
            onFlip={() => revealOne?.(property.traitType)}
          />
        </div>
      ))}
    {stage === 'properties' &&
      currentGribble.properties.map((property) => (
        <div className={styles.property} key={property.traitType}>
          <TraitRevealCard
            {...traitAttributesTransformer.toTraitAttribute(
              { traitType: property.traitType, value: property.value.toString() },
              CollectionEntities.Gribbles,
            )}
            flipped={property.revealed}
            onFlip={() => revealOne?.(property.traitType)}
          />
        </div>
      ))}
  </>
);
